enum CheckboxType {
	BOX = 'BOX',
	RADIO = 'RADIO',
}

export default CheckboxType;